import React from 'react';
import {
    Box,
    Typography,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    IconButton,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { vortxColors } from '../core/theme.js';

/**
 * TierEditor - Inline editor for energy tiers
 *
 * @param {Array} tiers - Array of { max_usage, rate }
 * @param {Function} onChange - Callback(newTiers)
 */
function TierEditor({ tiers, onChange }) {
    const addTier = () => {
        onChange([...tiers, { max_usage: '', rate: '' }]);
    };

    const removeTier = (index) => {
        const newTiers = [...tiers];
        newTiers.splice(index, 1);
        onChange(newTiers);
    };

    const updateTier = (index, field, value) => {
        const newTiers = [...tiers];
        newTiers[index] = { ...newTiers[index], [field]: value };
        onChange(newTiers);
    };

    return (
        <Box sx={{ mt: 2, bgcolor: alpha(vortxColors.gold, 0.05), p: 2, borderRadius: 2 }}>
            <Typography variant="caption" sx={{ display: 'block', mb: 1, color: 'text.secondary' }}>
                Define energy rate tiers. Use empty or "infinity" for the final tier's max usage.
            </Typography>

            <Table size="small" sx={{ mb: 1 }}>
                <TableHead>
                    <TableRow>
                        <TableCell>Max Usage (kWh)</TableCell>
                        <TableCell>Rate ($/kWh)</TableCell>
                        <TableCell width={50}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tiers.map((tier, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                <TextField
                                    size="small"
                                    placeholder={index === tiers.length - 1 ? "Infinity" : "e.g. 500"}
                                    value={tier.max_usage}
                                    onChange={(e) => updateTier(index, 'max_usage', e.target.value)}
                                    sx={{ bgcolor: 'background.paper' }}
                                    fullWidth
                                />
                            </TableCell>
                            <TableCell>
                                <TextField
                                    size="small"
                                    placeholder="0.15"
                                    value={tier.rate}
                                    onChange={(e) => updateTier(index, 'rate', e.target.value)}
                                    sx={{ bgcolor: 'background.paper' }}
                                    fullWidth
                                />
                            </TableCell>
                            <TableCell>
                                <IconButton size="small" onClick={() => removeTier(index)}>
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>

            <Button
                startIcon={<AddIcon />}
                size="small"
                onClick={addTier}
                sx={{ color: vortxColors.gold }}
            >
                Add Tier
            </Button>
        </Box>
    );
}

export default TierEditor;
